import { FileJson, X } from "lucide-react";
import { useEffect, useState } from "react";
import { getPayload } from "../../services/payloadService";
import { StateBlock } from "./StateBlock";

interface PayloadModalProps {
  path: string;
  onClose: () => void;
}

export function PayloadModal({ path, onClose }: PayloadModalProps) {
  const [payload, setPayload] = useState<unknown>();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string>();

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    setError(undefined);

    getPayload(path)
      .then((data) => {
        if (isMounted) {
          setPayload(data);
        }
      })
      .catch((err: Error) => {
        if (isMounted) {
          setError(err.message);
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [path]);

  return (
    <div className="modal-backdrop" role="presentation">
      <section className="payload-modal" role="dialog" aria-modal="true" aria-label="Raw payload viewer">
        <div className="modal-heading">
          <div>
            <p>Raw payload viewer</p>
            <h3><FileJson size={18} aria-hidden="true" /> ADLS Payload</h3>
            <span>{path}</span>
          </div>
          <button className="icon-button" type="button" onClick={onClose} title="Close raw payload viewer">
            <X size={18} aria-hidden="true" />
          </button>
        </div>

        {isLoading && <StateBlock type="loading" title="Loading payload" message="Reading raw JSON through Azure Functions." />}
        {error && <StateBlock type="error" title="Payload unavailable" message={error} />}
        {!isLoading && !error && <pre>{JSON.stringify(payload, null, 2)}</pre>}
      </section>
    </div>
  );
}
